"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedPartialCapacity1850 = exports.AggregatedRegionPartialCapacity = void 0;
const memoizee_1 = __importDefault(require("memoizee"));
class AggregatedRegionPartialCapacity {
    constructor(periods) {
        this.periods = periods;
        this.countWeekDayHolidays = (0, memoizee_1.default)(() => {
            return Math.round(this.periods.reduce((total, period) => total + period.countWeekDayHolidays(), 0));
        });
        this.countWeekDayTimeOff = (0, memoizee_1.default)(() => {
            return Math.round(this.periods.reduce((total, period) => total + period.countWeekDayTimeOff(), 0));
        });
        this.countWorkingDays = (0, memoizee_1.default)(() => {
            return Math.round(this.periods.reduce((total, period) => total + period.countWorkingDays(), 0));
        });
        this.countWorkingHours = (0, memoizee_1.default)(() => {
            return this.periods.reduce((total, period) => total + period.countWorkingHours(), 0);
        });
    }
}
exports.AggregatedRegionPartialCapacity = AggregatedRegionPartialCapacity;
class AggregatedPartialCapacity1850 {
    constructor(periods) {
        this.periods = periods;
        this.countWorkingHours = (0, memoizee_1.default)(() => {
            return this.periods.reduce((total, period) => total + period.countWorkingHours(), 0);
        });
    }
}
exports.AggregatedPartialCapacity1850 = AggregatedPartialCapacity1850;
//# sourceMappingURL=AggregatedRegionPartialCapacityPeriod.js.map